import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import {
  GRUPO_ATIVIDADE_FLORESTAL_LABEL,
  getAtividadeEmpreendimentoLabel,
  montarEnderecoEmpreendimento,
} from "../utils/constants";
import { formatCpfCnpj, formatPhone } from "../utils/formatters";

function RevisaoProtocoloPanel({
  processoNome,
  empreendimento,
  especificacao,
  usuario,
  requerente,
  loadingUsuario = false,
  numeroProcessoPreview,
}) {
  const pessoaRequerente = requerente || usuario;
  const nomeCompletoRequerente = pessoaRequerente
    ? pessoaRequerente.nomeExibicao?.trim() ||
      `${pessoaRequerente.nome || ""} ${pessoaRequerente.sobrenome || ""}`.trim()
    : "";
  const nomeRequerente = nomeCompletoRequerente || "-";
  const documentoRequerente = pessoaRequerente?.cpf
    ? formatCpfCnpj(String(pessoaRequerente.cpf))
    : "-";
  const contatoRequerente = pessoaRequerente?.telefone
    ? formatPhone(pessoaRequerente.telefone)
    : "-";
  const enderecoFormatado = montarEnderecoEmpreendimento(empreendimento);
  const atividadeLabel = getAtividadeEmpreendimentoLabel(
    empreendimento?.atividadeEmpreendimento,
  );

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Informações do processo
      </Typography>
      {numeroProcessoPreview && (
        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>Processo:</strong> {numeroProcessoPreview}
        </Typography>
      )}
      <Typography variant="body1" sx={{ mb: 1 }}>
        <strong>Tipo de processo:</strong> {processoNome || "-"}
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        <strong>{GRUPO_ATIVIDADE_FLORESTAL_LABEL.toUpperCase()}</strong>
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {atividadeLabel}
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        <strong>Especificação:</strong> {especificacao || "-"}
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" gutterBottom>
        Informações do Requerente
      </Typography>
      {loadingUsuario ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>REQUERENTE:</strong> {nomeRequerente}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>CPF/CNPJ:</strong> {documentoRequerente}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Contato:</strong> {contatoRequerente}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Endereço:</strong> {enderecoFormatado}
          </Typography>
        </>
      )}
    </Box>
  );
}

export default RevisaoProtocoloPanel;
